import config from '../config'
import http from '../http'

export default {

	updateSensitive:async function(payload) {
		const res = await http({
			url:config.UPDATA_SENSITIVE_TRUE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	updateStoreRate:async function(payload) {
		const res = await http({
			url:config.UPDATE_STORE_RATE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getStoreItemDetail:async function(payload) {
		const res = await http({
			url:config.GET_IMPORT_DETAIL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	initStoreItemError:async function(payload) {
		const res = await http({
			url:config.GET_IMPORT_ERROR_DETAIL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	initStoreItem:async function(payload) {
		const res = await http({
			url:config.INIT_STORE_ITEM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getOnlineGoods:async function(payload) {
		const res = await http({
			url:config.GET_OLIONE_PRODUCT,
			method: 'post',
			data: {
				...payload
			}
		})
		console.log(444)
		console.log(res)
		return res.data
	},
	buyerUpdateCost:async function(payload) {
		const res = await http({
			url:config.BUYER_UPDATECOST,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	checkInventory: async function(payload) {
		const res = await http({
			url:config.SHOPOEDER_CHECK_INVENTORY,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateSeparateNum: async function(payload) {
		const res = await http({
			url:config.UPDATE_SEPARATENUM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateIndependent: async function(payload) {
		const res = await http({
			url:config.updata_INDEPENDENT,
			method: 'post',
			data: payload
		})
		return res.data
	},
	massDeleteStoreItem: async function(payload) {
		const res = await http({
			url:config.MASS_DELITE_SOTORE_ITEM_ALL,
			method: 'post',
			data: payload
		})
		return res.data
	},
	updateBindStoreItemAddition: async function(payload) {
		const res = await http({
			url:config.UPDATE_BIND_STOREITEM_ADDITION,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	updateEncoding: async function(payload) {
		const res = await http({
			url:config.UPDATE_ENCODING,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	copyStoreItemByStore: async function(payload) {
		const res = await http({
			url:config.SHOPOEDER_COPY_STYOREITEM_BYSTORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},


	addStoreItemNotProduct: async function(payload) {
		const res = await http({
			url:config.ADD_NEW_STOREITEM_NOT_PRODUCT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},


	updateGroupInfo: async function(payload) {
		const res = await http({
			url:config.UPDATA_GROUP_INFO,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	updataComponent: async function(payload) {
		const res = await http({
			url:config.UPDATE_COMPONENT,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getStoreItemDegree: async function(payload) {
		const res = await http({
			url:config.GET_STORE_IETM_DEGREE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateStoreParentImage: async function(payload) {
		const res = await http({
			url:config.UPDATA_STORE_PARENT_IMAGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	updateStoreItemImage: async function(payload) {
		const res = await http({
			url:config.UPDATA_STORE_IMAGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	//更新运输
	updateShipDay: async function(payload) {
		const res = await http({
			url:config.UPDATA_SHIPPED_DAYS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//仓库ID获取收费规则
	getRuler: async function(payload) {
		const res = await http({
			url:config.GET_RULES_BY_STOREID,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//仓库帐号更新在仓库存
	updateStoreNumBystore: async function(payload) {
		const res = await http({
			url:config.UPDATE_STORE_NUM_BY_STORE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	bindItem: async function(payload) {
		const res = await http({
			url:config.BIGN_ITEMS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//查看绑定情况 -- GROUPID
	viewBindInfo:async function(payload) {
		const res = await http({
			url: config.GET_AUTO_BIND_ITEMS,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//修改绑定库存产品
	updateBindStoreItem:async function(payload) {
		const res = await http({
			url: config.UPDATE_BIND_STORE_ITEMS,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//更新是否自动开启预售
	updateIsAutoPre:async function(payload) {
		const res = await http({
			url: config.UPDATA_IS_AUTO_PRE,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//修改母SKU
	updateGroup:async function(payload) {
		const res = await http({
			url: config.UPDATA_GROUP_NAME,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//删除组
	deleteGroup:async function(payload) {
		const res = await http({
			url: config.DELETE_GROUP,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//修改倍率
	updatRate:async function(payload) {
		const res = await http({
			url: config.UPDATA_RAGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//文件上传解析
	fileUpload:async function(payload) {
		const res = await http({
			url: config.FILE_UPLOAD,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库商品的库存日志
		getInstockoperaterecore:async function(payload) {
		const res = await http({
			url: config.GET_IN_STOCK_OPERATE_RECORD,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库商品的库存周转率
	getStoreProductInventoryTurnover:async function(payload) {
 	const res = await http({
 		url: config.GET_STOER_PRODUCT_INVENTORY_TURNOVER,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
	//获取仓库产品的销售情况
	getStoreSales:async function(payload) {
 	const res = await http({
 		url: config.VIEW_STORE_SALSE_INFO,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //仓库获取用户仓库物品信息
 getStoreItemBystore:  async function(payload) {
 	const res = await http({
 		url: config.GET_STORE_ITEMS_STORE,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },

 
 
 //获取统计数据
 getDiscount:  async function(payload) {
 	const res = await http({
 		url: config.DISCOUNT,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //卖家获取用户仓库物品信息
 getStoreItem:  async function(payload) {
 	const res = await http({
 		url: config.GET_STORE_ITEMS,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 
 getStoreItem01:  async function(payload) {
 	const res = await http({
 		url: config.SEARCH_CUSCODE,
 		method: 'get',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //获取用户仓库下商品的总数
 getStoreItemCount:  async function(payload) {
 	const res = await http({
 		url: config.GET_STORE_ITEM_COUNT,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 
 
 //创建采购单 
 createCaiGouTable:async function(payload) {
 	const res = await http({
 		url: config.CREATE_CAIGUO_TABLE,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //删除用户仓库下的物品信息
 deleStoreItems:async function(payload) {
 	const res = await http({
 		url: config.DELE_STORE_ITEMS,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //解绑已绑定的商品
 jiebanItems:async function(payload) {
 	const res = await http({
 		url: config.JIE_BAN_ITEMS,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //更新商品信息
 // updateItemInfo:async function(payload) {
 // 	const res = await http({
 // 		url: config.UPDATE_ITEM_INFO,
 // 		method: 'post',
 // 		data: {
 // 			...payload
 // 		}
 // 	})
 // 	return res.data
 // },
 
 //同步更新
 updateStoreItem:async function(payload) {
 	const res = await http({
 		url: config.UPDATE_DATA_USER_STORE_ITEMS,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //更新当前库存数量到shopee
 updateShopeeItemStock:async function(payload) {
 	const res = await http({
 		url: config.UPDATA_SHOPEE_ITEM_STOCK,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //卖家用户更新仓库商品基本信息
 sellerUpdateStoreItemDetail:async function(payload) {
 	const res = await http({
 		url: config.SELLER_UPDATE_STORE_ITEM_DETAIL,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },

 sellerUpdateStoreItem:async function(payload) {
	const res = await http({
		url: config.SELLER_UPDATA_STOREITEM,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},

updateDefaultActivityPrice:async function(payload) {
   const res = await http({
	   url: config.UPDATE_DEFAULT_ACTIVITY_PRICE,
	   method: 'post',
	   data: payload
   })
   return res.data
},

setAutoActivity:async function(payload) {
   const res = await http({
	   url: config.SET_AUTO_ACTIVITY,
	   method: 'post',
	   data:  {
		...payload
	}
   })
   return res.data
},

getMarketingActivityList:async function(payload) {
   const res = await http({
	   url: config.GET_MARKETING_ACTIVITY_LIST,
	   method: 'post',
	   data: payload
   })
   return res.data
},

 //卖家用户开启或者关闭自动更新
 sellerUpdateSynchrony:async function(payload) {
 	const res = await http({
 		url: config.SELLER_UPDATE_SYNCHRONY,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 //仓储用户更新仓库商品的在仓库存与仓位
 storeUpdateStoreNumAndAddress:async function(payload) {
 	const res = await http({
 		url: config.STORE_UPDATE_STORE_NUM_ADDRESS,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },

 //仓储用户更新仓库商品的在仓库存与仓位
 storeUpdateStoreNumAndAddressCopy:async function(payload,token) {
	const res = await http({
		url: config.STORE_UPDATE_STORE_NUM_ADDRESS,
		method: 'post',
		data: {
			...payload
		},
		headers:{
			token:token
		}
	})
	return res.data
},
 
 //是否开启预售
 isAutoPre:async function(payload) {
 	const res = await http({
 		url: config.IS_AUTO_PRE,
 		method: 'post',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 getStockRemind:async function(payload) {
 	const res = await http({
 		url: config.GET_STOCK_REMIND,
 		method: 'get',
 		data: {
 			...payload
 		}
 	})
 	return res.data
 },
 
 //超级用户根据仓库编码变更分销商价格
 updatePriceByCusCode:async function(payload) {
	const res = await http({
		url: config.UPDATE_PRICE_BY_CUSCODE,
		method: 'post',
		data: {
			...payload
		}
	})
	return res.data
},
//超级用户根据仓库编码变更分销商价格
updatePriceByCusCode:async function(payload) {
   const res = await http({
	   url: config.UPDATE_PRICE_BY_CUSCODE,
	   method: 'post',
	   data: payload
   })
   return res.data
},

//更新分销商等级
updateUserDistributorLevel:async function(payload) {
   const res = await http({
	   url: config.UPDATE_USER_DISTRIBUTOR_LEVEL,
	   method: 'post',
	   data: payload
   })
   return res.data
},

}
